export default {
  apiNotAvailable: 'NPM-API nicht verfügbar',
  systemKnown: 'System der NPM-API bekannt',
  systemUnknown: 'System der NPM-API unbekannt',
};
